import React from "react";

/**
 * Bottom-of-page upsell CTA. Phase 1 placeholder — the free-account signup flow
 * ships in Phase 2, so the button is intentionally non-functional ("coming
 * soon"). CSV download stays free and ungated above this banner.
 */
const UpsellBanner: React.FC = () => {
  return (
    <div className="mt-10 rounded-2xl border border-sagelyn-accent-warm/40 bg-sagelyn-accent-warm/10 p-6 text-center">
      <h3 className="text-lg font-semibold text-sagelyn-foreground">
        Want to save your contacts and push them to your CRM?
      </h3>
      <p className="mx-auto mt-1 max-w-xl text-sm text-sagelyn-muted">
        Create a free Sagelyn account to keep your contacts and sync them
        straight into your CRM. Coming soon.
      </p>
      <button
        type="button"
        disabled
        title="Coming soon"
        className="mt-4 inline-flex cursor-not-allowed items-center gap-2 rounded-lg bg-sagelyn-accent-warm px-5 py-2.5 text-sm font-semibold text-sagelyn-charcoal opacity-70"
      >
        Create a free account
        <span className="rounded-full bg-sagelyn-charcoal/15 px-2 py-0.5 text-xs">
          Soon
        </span>
      </button>
    </div>
  );
};

export default UpsellBanner;
